import React from 'react';
import SelectStudent from '../../../studentTransfer/components/selectStudent';
import { useSearchStudentsHandler } from '../../../studentTransfer/customHooks';
import { searchStudents } from '../searchStudent/constants';
import { useWizard } from '../../../../components/wizard/WizardContext';
import { getColumnList } from './tableColumnsConfig';
import FilterForm from './FilterForm';
import RefundTipsCard from './RefundTipsCard';
import SelectStudentFooter from '../../../studentTransfer/components/selectStudent/SelectStudentFooter';
// import { rectRefundStep2InitValues, rectRefundStep3InitValues } from '../config';
import { MULTI_TYPE_REFUND, refundStepsEmptyForms } from '../config';

const SelectStudentWrapper = () => {

    const { next, values, updateValues, setValues } = useWizard();
    const { selectedStudent, rectRefundStep2Data, refundType, multiTypeRefundStep2Data } = values;
    const { searchHandler } = useSearchStudentsHandler();
    const handleSearch = (...args) => searchHandler(...args, searchStudents);

    const {value : refundTypeKey, validateStudent} = values?.refundType;


    const validate = () => {

        const prevSelectedStudentAppId = refundType?.value === MULTI_TYPE_REFUND 
        ? multiTypeRefundStep2Data?.selectedStudentAppId
        : rectRefundStep2Data?.selectedStudentAppId;

        if (selectedStudent?.applicationId !== prevSelectedStudentAppId) {
            // updateValues("rectRefundStep2Data", rectRefundStep2InitValues);
            // updateValues("rectRefundStep3Data", rectRefundStep3InitValues);
            setValues(vals => ({...vals, ...refundStepsEmptyForms }))
        }

        if(!validateStudent(selectedStudent)) return;

        next();
    }

    return (
        <>
            <div className='d-flex'>
                <SelectStudent
                    searchHandler={handleSearch}
                    getColumnList={getColumnList}
                    FilterForm={FilterForm}
                />

                <RefundTipsCard
                    key={refundTypeKey}
                />
            </div>

            <SelectStudentFooter
                validate={validate}
                selectedStudent = {selectedStudent}
            />


        </>
    );
}

export default SelectStudentWrapper;